import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Clock, Gauge, FileCheck2, XCircle, CircleDot } from "lucide-react";

const MAP = {
  verified: { label: "Verified", icon: ShieldCheck, cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  data_checked: { label: "Data Checked", icon: ShieldCheck, cls: "bg-sky-500/10 text-sky-700 border-sky-500/30" },
  pending: { label: "Pending Review", icon: Clock, cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  mileage: { label: "Mileage Warning", icon: Gauge, cls: "bg-orange-500/10 text-orange-700 border-orange-500/30" },
  v5c: { label: "V5C Submitted", icon: FileCheck2, cls: "bg-blue-500/10 text-blue-700 border-blue-500/30" },
  held: { label: "On Hold", icon: XCircle, cls: "bg-red-500/10 text-red-700 border-red-500/30" },
  live: { label: "Live", icon: CircleDot, cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  draft: { label: "Draft", icon: CircleDot, cls: "bg-slate-500/10 text-slate-600 border-slate-500/30" },
  removed: { label: "Removed", icon: XCircle, cls: "bg-slate-500/10 text-slate-600 border-slate-500/30" },
  expired: { label: "Expired", icon: XCircle, cls: "bg-slate-500/10 text-slate-600 border-slate-500/30" },
  sold: { label: "Sold", icon: CircleDot, cls: "bg-slate-800/10 text-slate-800 border-slate-800/30" },
  pending_review: { label: "Pending Review", icon: Clock, cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
};

export function TrustBadge({ type, label, testId }) {
  const m = MAP[type] || MAP.draft;
  const Icon = m.icon;
  return (
    <Badge variant="outline" data-testid={testId} className={`gap-1 font-medium border ${m.cls}`}>
      <Icon className="w-3.5 h-3.5" />
      {label || m.label}
    </Badge>
  );
}
